import { gql } from '@apollo/client';

export default gql`
  mutation deletePurchaseOrder($_id: String) {
    deletePurchaseOrder(_id: $_id) {
      ok
      message
      error
    }
  }
`;
